import { Component, OnInit } from '@angular/core';
import { RouterService } from "../../../services/router/router.service";
import { UserService } from "src/app/services/user/user.service";
import firebase from "firebase/app";
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { TagsService } from 'src/app/services/tags/tags.service';

@Component({
  selector: 'app-kpi',
  templateUrl: './kpi.page.html',
  styleUrls: ['./kpi.page.scss'],
})
export class KpiPage implements OnInit {
  db: any;
  userName: string;
  kpiblock: boolean = true;
  constructor(
    private routerService: RouterService,
    public userService: UserService,
    public languageService: LanguagesService,
    private tagsService:TagsService,
  ) {
    this.db = firebase;
    this.getUserNameGNX();
  }

  ngOnInit() {
    this.tagsService.setEventTag('indicators_page','indicators_screen_viewed');
    let _this = this;
    window.addEventListener("kpiListStatus", function (event: any) {
      if (event && event.detail && event.detail.length <= 0) {
        _this.kpiblock = false;
      }
    });
  }

  kpiSelected(kpi) {
    const kpiId = kpi.idgraph;
    this.routerService.redirect(`app/kpi/${kpiId}`);
  }

  async getUserNameGNX() {
    await this.userService.getUserInfo().subscribe((info: any) => {
      if (info && info.gnxCredential1) {
        this.userName = info.gnxCredential1;
      }
    });
  }
  get getTextIUPageKPI() {
    return this.languageService.textsIU.page_kpi;
  }
}
